/** Verify REST reachability before allowing the connectivity FSM to resume writes. */
export async function probeRestConnectivity(apiUrl: string): Promise<boolean> {
  try {
    // The API origin itself is not a route; probing it reports a healthy API as offline.
    const target = apiUrl === '' ? '/' : new URL('/health/live', apiUrl).toString();
    const response = await fetch(target, {
      method: 'HEAD',
      cache: 'no-store',
    });
    return response.ok;
  } catch {
    return false;
  }
}
